import { createContext } from "react";

export const LoginContext = createContext()
export const LoginFormContext = createContext()
export const LoginReportContext = createContext()